var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        title: _vm.$t(
          _vm.isEdit ? "operation.edit_business" : "operation.create_business"
        ),
        width: "640px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        closed: _vm.resetForm,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "businessForm",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "110px" },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("operation.business_name"),
                prop: "business_name",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  maxlength: "128",
                  "show-word-limit": "",
                  placeholder: _vm.$t("operation.enter_business_name"),
                },
                model: {
                  value: _vm.form.business_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "business_name", $$v)
                  },
                  expression: "form.business_name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("operation.business_type"),
                prop: "business_type",
              },
            },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.onBusinessTypeChange },
                  model: {
                    value: _vm.form.business_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "business_type", $$v)
                    },
                    expression: "form.business_type",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(_vm._s(_vm.$t("operation.self_operated"))),
                  ]),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v(_vm._s(_vm.$t("operation.franchise"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("operation.business_region"),
                prop: "country_code",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    disabled: _vm.isEdit,
                    loading: _vm.regionLoading,
                    placeholder: _vm.$t("operation.select_region"),
                  },
                  on: { change: _vm.onRegionChange },
                  model: {
                    value: _vm.form.country_code,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "country_code", $$v)
                    },
                    expression: "form.country_code",
                  },
                },
                _vm._l(_vm.regionOptions, function (region) {
                  return _c("el-option", {
                    key: region.value,
                    attrs: { label: region.label, value: region.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("operation.business_currency"),
                prop: "currency",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    disabled: _vm.isEdit || !_vm.form.country_code,
                    placeholder: _vm.$t("operation.select_currency"),
                  },
                  model: {
                    value: _vm.form.currency,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "currency", $$v)
                    },
                    expression: "form.currency",
                  },
                },
                _vm._l(_vm.currencyOptions, function (currencyOption) {
                  return _c("el-option", {
                    key: currencyOption,
                    attrs: { label: currencyOption, value: currencyOption },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm.form.business_type === 2
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("operation.related_franchisee"),
                    prop: "franchisee_id",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        loading: _vm.franchiseeLoading,
                        filterable: "",
                        placeholder: _vm.$t("operation.select_franchisee"),
                      },
                      model: {
                        value: _vm.form.franchisee_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "franchisee_id", $$v)
                        },
                        expression: "form.franchisee_id",
                      },
                    },
                    _vm._l(
                      _vm.filteredFranchiseeOptions,
                      function (franchisee) {
                        return _c("el-option", {
                          key: franchisee.franchisee_id,
                          attrs: {
                            label: _vm.formatFranchisee(franchisee),
                            value: franchisee.franchisee_id,
                          },
                        })
                      }
                    ),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("operation.description"),
                prop: "description",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 4,
                  maxlength: "512",
                  "show-word-limit": "",
                  placeholder: _vm.$t("operation.enter_description"),
                },
                model: {
                  value: _vm.form.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "description", $$v)
                  },
                  expression: "form.description",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("components.cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitting },
              on: { click: _vm.submit },
            },
            [_vm._v(_vm._s(_vm.$t("components.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }